var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-box",staticStyle:{"width":"800px","height":"1100px","padding":"30px 50px 0 50px","position":"relative"},style:({
    'background-image': ("url(" + _vm.bgImage + ")"),
    'background-size': "100% 100%"
  })},[_c('tk-flex',{staticClass:"full-width",staticStyle:{"padding":"20px","margin-top":"330px"},attrs:{"middle":"","center":""}},[_c('img',{attrs:{"src":_vm.qrCode,"width":"420px","height":"420px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }